import {
  UPDATE_ASK_VYRILL_STATE,
  RESET_ASK_VYRILL_STATE,
  UPDATE_SINGLE_MESSAGE,
  UPDATE_ASK_VYRILL_MODAL,
} from "./Actions";

// TODO:
export interface RootState {
  askVyrill: askVyrillState;
}

interface askVyrillState {
  selectedPrompt: string;
  messages: any[];
  conversationId: string;
  loadFromHistory: boolean;
  allPrompts: any[];
  isFirstPrompt: boolean;
  allConversations: any[];
  messagesLoading: boolean;
  askVyrillError: boolean;
  historyLoading: boolean;
  askVyrillTimoutError: boolean;
  askVyrillDuration: {
    value: string;
    label: string;
  };
  custom_start_date:string;
  custom_end_date:string;
  isNewChat: boolean;
  askVyrillModal: {
    shouldOpen: boolean;
    requestFrom: string;
  };
}

const _nullState: askVyrillState = {
  selectedPrompt: "",
  messages: [],
  conversationId: "",
  loadFromHistory: false,
  allPrompts: [],
  isFirstPrompt: false,
  allConversations: [],
  messagesLoading: false,
  askVyrillError: false,
  askVyrillTimoutError: false,
  historyLoading: false,
  askVyrillDuration: {
    value: "1y",
    label: "",
  },
  custom_start_date : "",
  custom_end_date : "",
  isNewChat: false,
  askVyrillModal: { shouldOpen: false, requestFrom: "" },
};

const askVyrill = (state: askVyrillState = _nullState, payload: any = {}) => {
  const { data, type } = payload;
  switch (type) {
    case UPDATE_ASK_VYRILL_STATE:
      return { ...state, ...data };

    case UPDATE_SINGLE_MESSAGE:
      return {
        ...state,
        messages: state.messages.map((obj) =>
          obj._id === data.id ? { ...obj, ...data.updatedMessage } : obj
        ),
      };

    case UPDATE_ASK_VYRILL_MODAL:
      return {
        ...state,
        askVyrillModal: { ...state.askVyrillModal, ...data },
      };

    case RESET_ASK_VYRILL_STATE:
      return {
        ..._nullState,
      };

    default:
      return state;
  }
};

export default askVyrill;
